import axios from "axios";
import { BACKEND_ENDPOINT } from "../constants";

export const sendComputeRequest = async (postData) => {
  try {
    const res = await axios.post(BACKEND_ENDPOINT, postData);
    return res;
  } catch (error) {
    return error;
  }
};
